import html5 from "../assets/img/html5-plain.svg";
import css3 from "../assets/img/css3-plain.svg";
import js from "../assets/img/javascript-plain.svg";
import bootstrap from "../assets/img/bootstrap-plain.svg";
import mui from "../assets/img/materialui-plain.svg";
import sass from "../assets/img/sass-original.svg";
import reactJS from "../assets/img/react-original.svg";
import express from "../assets/img/express-original.svg";
import nodeJS from "../assets/img/nodejs-plain.svg";
import redux from "../assets/img/redux-original.svg";

export const techSkills2 = [
  {
    name: "HTML5",
    iconImg: html5,
  },
  {
    name: "CSS3",
    iconImg: css3,
  },
  {
    name: "Javascript",
    iconImg: js,
  },
  {
    name: "Bootstrap",
    iconImg: bootstrap,
  },
  {
    name: " MUI",
    iconImg: mui,
  },
  {
    name: "Sass",
    iconImg: sass,
  },
  {
    name: "React JS",
    iconImg: reactJS,
  },
  {
    name: "Redux",
    iconImg: redux,
  },
  {
    name: "Node JS",
    iconImg: nodeJS,
  },
  {
    name: "Express JS",
    iconImg: express,
  },
];
